import React, {createContext, Dispatch, ReactNode, useContext, useEffect, useReducer, useState} from 'react';
import {Game, Player, UserInfo} from "../../core/models/utilTypes";
import {UserService} from "../../core/service/user.service";
import {TeamService} from "../../core/service/team.service";
import {AuthService} from "../../core/service/auth.service";
import authReducer from "./authReducer";

interface AppContextType {
  userInfo: UserInfo;
  dispatch: Dispatch<any>;
  authService: AuthService;
  teamService: TeamService;
  userService: UserService;
  teamPlayers: Player[];
  setTeamPlayers: React.Dispatch<React.SetStateAction<Player[]>>;
  teamGames: Game[];
  setTeamGames: React.Dispatch<React.SetStateAction<Game[]>>;
}

export const AppContext = createContext({} as AppContextType);

type Props = {
  children: ReactNode
}

export const ContextProvider: React.VFC<Props> = (props) => {

  const authService = AuthService.instance;
  const teamService = TeamService.instance;
  const userService = UserService.instance;
  const [teamPlayers, setTeamPlayers] = useState<Player[]>([]);
  const [teamGames, setTeamGames] = useState<Game[]>([])

  const [state, dispatch] = useReducer(
    authReducer.reducer,
    authReducer.initialState
  );

  const value: AppContextType = {
    userInfo: state as UserInfo,
    dispatch: dispatch,
    authService: authService,
    teamService: teamService,
    userService: userService,
    teamPlayers: teamPlayers,
    setTeamPlayers: setTeamPlayers,
    teamGames: teamGames,
    setTeamGames: setTeamGames,
  }

  useEffect(()=> {
    authService.isLogin(dispatch);
    return
  }, [])

  return (
    <AppContext.Provider value={value}>
      {props.children}
    </AppContext.Provider>
  );
};
